/**
 * Created by katarinababic on 13.6.25.
 */
import { useRootStore } from '../Store/useRootStore';
import { useAnalyticsPeriodDisplayString } from './useAnalyticsHealthDataSummary';
import { useQuery } from '@tanstack/react-query';
import { ActivityAnalyticsApi, AggregateWindow } from '../Model/Activity/ActivityAnalytics';

export const seriesWindow: { [key: string]: AggregateWindow } = { week: 'day', month: 'day', year: 'month' };

export function useAnalyticsSummary() {
  const { analyticsWorkout } = useRootStore();
  const displayString = useAnalyticsPeriodDisplayString();

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['useAnalyticsSummary', analyticsWorkout.periodFilter, displayString],
    queryFn: () => {
      const [startDateTime, endDateTime] = analyticsWorkout.selectedDateRange;
      const window = seriesWindow[analyticsWorkout.periodFilter] ?? 'day';

      return ActivityAnalyticsApi.summary({ startDateTime, endDateTime, window });
    },
  });

  return { data, isLoading, error, refetch };
}
